import React from 'react'
import useUtils from '@/hooks/useUtils'
import Content from './Content.jsx'
import ListLinks from './ListLinks.jsx'
import { get } from 'lodash'
import PropTypes from 'prop-types'
import { motion, AnimatePresence, useTransform, useScroll } from 'framer-motion'
// styles
import './styles.ol.scss'

export default function OurLinks({ data }) {
  const { device } = useUtils()
  const { content, list_links, picture } = data
  const feature_image = get(picture, ['feature_image'], null)
  const { scrollYProgress } = useScroll()

  const translateY = useTransform(
    scrollYProgress,
    // Map x from these values:
    [0, 1],
    // Into these values:
    ['-5%', '-20%'],
  )

  const validatedHeightImg = () => {
    if (list_links.length <= 3) {
      return 'h-[700px]'
    }

    if (list_links.length <= 5) {
      return 'h-[950px]'
    }

    return 'h-[1050px]'
  }

  return (
    <section className="mainSectionOursLinks">
      <div className="containerOursLink">
        <div className="containerContent">
          <Content data={content} />
          <ListLinks data={list_links} />
        </div>
        <AnimatePresence>
          {device === 'desktop' ? (
            <motion.div
              transition={{
                duration: 0.7,
                delay: 0.2,
              }}
              viewport={{
                once: true,
              }}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              exit={{ opacity: 1 }}
              className="containerImg"
            >
              {feature_image ? (
                <div className="containerAnimation">
                  <motion.img
                    className={`${validatedHeightImg()}`}
                    style={{ translateY: translateY }}
                    alt={`alt_${feature_image.title}`}
                    title={feature_image.title}
                    src={feature_image.url}
                  />
                </div>
              ) : (
                <p>No Img</p>
              )}
            </motion.div>
          ) : null}
        </AnimatePresence>
      </div>
    </section>
  )
}

OurLinks.propTypes = {
  data: PropTypes.object,
}
